import { BOTTOM_MODAL_SHADOW } from "components/common/BottomModal/BottomModal";
import { ActiveType } from "../useBottomMenu";
import { AddImage } from "./AddImage/AddImage";
import { Delete } from "./Delete/Delete";
import { Sort } from "./Sort/Sort";

export interface ContentProps {
    activeType: ActiveType | null;
    closePopup: () => void;
}

export const Content = ({ activeType, closePopup }: ContentProps) => {
    return (
        <div
            className="absolute left-0 right-0 flex flex-col gap-2 mb-2 overflow-hidden bg-white border shadow-2xl bottom-full rounded-xl border-irGray-400 dark:border-darkSurface-600"
            onClick={closePopup}
            style={{ boxShadow: BOTTOM_MODAL_SHADOW }}
        >
            {activeType === "add" && <AddImage handleClose={closePopup} isOpen={activeType === "add"} />}
            {activeType === "delete" && (
                <div className="px-4 py-2 text-black border rounded-lg dark:bg-darkSurface-200 dark:text-white border-irGray-400 dark:border-darkSurface-400">
                    <Delete handleClose={closePopup} />
                </div>
            )}
            {activeType === "sort" && <Sort />}
        </div>
    );
};
